<template>
  <div
    class="teleconsultas"
    :class="loadingContent ? 'loading large' : ''"
  >
    <lila-message :alert-data="alert" />

    <div v-show="!loadingContent">
      <table
        v-if="data.teleconsultasList.length > 0"
        class="teleconsultas-table"
      >
        <thead>
          <tr>
            <th>Data</th>
            <th>Duração</th>
            <th>Profissional</th>
            <th>Status</th>
            <th>Desfecho</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in data.teleconsultasList"
            :key="item.VideoCallId"
          >
            <td>{{ formatDate(item.CreatedAt) }}</td>
            <td>{{ formatDuration(item.DurationInSeconds) }}</td>
            <td>{{ item.ProfessionalName || "-" }}</td>
            <td>{{ item.StatusName || "-" }}</td>
            <td class="desfecho-cell">
              <span
                v-if="item.Outcome && item.Outcome.length > 30"
                class="desfecho-text"
              >
                {{ item.Outcome.substring(0, 30) }}...
                <a
                  href="#"
                  class="ver-mais"
                  @click.prevent="openDesfechoModal(item)"
                >mais</a>
              </span>
              <span v-else>{{
                item.Outcome || "(sem desfecho registrado)"
              }}</span>
            </td>
          </tr>
        </tbody>
      </table>

      <div
        v-else
        class="empty-state"
      >
        <p>Nenhuma teleconsulta encontrada para este paciente.</p>
      </div>

      <lila-pagination
        :pagination-config="pagination"
        @custom-change-page-event="changePage"
      />

      <div
        class="modal"
        :class="modalDesfechoActive ? 'is-active' : ''"
      >
        <div
          class="modal-background"
          @click="closeDesfechoModal"
        />
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">
              Desfecho
            </p>
            <button
              class="delete"
              aria-label="close"
              @click="closeDesfechoModal"
            />
          </header>
          <section class="modal-card-body">
            <p>{{ selectedDesfecho }}</p>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Message from "@components/shared/message/Message.vue";
import Pagination from "@components/shared/pagination/Pagination.vue";

export default {
  components: {
    "lila-message": Message,
    "lila-pagination": Pagination
  },
  data() {
    return {
      data: {
        patientId: this.$route.params.id,
        teleconsultasList: []
      },
      loadingContent: false,
      alert: {
        message: "",
        type: "",
        show: false
      },
      pagination: {
        current: 0,
        totalPages: 0,
        perPage: 10
      },
      modalDesfechoActive: false,
      selectedDesfecho: ""
    };
  },
  watch: {
    $route(to) {
      this.data.patientId = to.params.id;
      this.getTeleconsultasList();
    }
  },
  created() {
    this.getTeleconsultasList();
  },
  methods: {
    getTeleconsultasList(page = 1) {
      this.alert.show = false;
      this.loadingContent = true;
      this.data.teleconsultasList = [];
      this.pagination.current = 0;
      this.pagination.totalPages = 0;

      this.$axios
        .get(
          `/api/call/patient/${this.data.patientId}/history?page=${page}&limit=${this.pagination.perPage}`,
          {
            headers: {
              Authorization: `bearer ${this.$Session.get(this.$userSessionName).token.Value}`
            }
          }
        )
        .then((res) => {
          this.data.teleconsultasList = res.data.Data || res.data || [];

          if (res.data.Pagination) {
            this.pagination.current = res.data.Pagination.CurrentPage;
            this.pagination.totalPages = res.data.Pagination.TotalPage;
            this.pagination.perPage = res.data.Pagination.ItemPerPage;
          }
        })
        .catch((error) => {
          this.$Utilities.verifyToken(error.response?.status);

          if (error.response?.status !== 404) {
            this.$Utilities.controlAlert(
              error.response?.data || "Erro ao carregar teleconsultas",
              this.alert,
              "danger"
            );
          }
        })
        .finally(() => {
          this.loadingContent = false;
        });
    },
    formatDate(dateString) {
      if (!dateString) return "-";
      const cleaned = dateString.replace(/\.\d+/, "").replace(/Z$/, "");
      return this.$Utilities.formatDateWithTime(
        cleaned,
        "YYYY-MM-DDTHH:mm:ss",
        "DD/MM/YYYY - HH:mm"
      );
    },
    formatDuration(seconds) {
      if (!seconds) return "-";
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      if (minutes === 0) return `${remainingSeconds}s`;
      return `${minutes}m${remainingSeconds}s`;
    },
    openDesfechoModal(item) {
      this.selectedDesfecho = item.Outcome;
      this.modalDesfechoActive = true;
    },
    closeDesfechoModal() {
      this.modalDesfechoActive = false;
      this.selectedDesfecho = "";
    },
    changePage(page) {
      this.getTeleconsultasList(page);
    }
  }
};
</script>

<style lang="scss" scoped>
.teleconsultas {
  padding: 20px;

  .teleconsultas-table {
    width: 100%;
    border-collapse: collapse;

    thead {
      th {
        text-align: left;
        font-weight: 600;
        color: #4f3f82;
        border-bottom: 2px solid #e0e0e0;
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid #f0f0f0;

        &:hover {
          background-color: #fafafa;
        }
      }

      td {
        padding: 16px;
        color: #666;
        vertical-align: top;
      }
    }
  }

  .desfecho-cell {
    max-width: 250px;
    color: #666;

    .ver-mais {
      color: #4f3f82;
      text-decoration: none;
      font-weight: 500;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .empty-state {
    text-align: center;
    padding: 40px 20px;
    color: #666;
  }
}

.modal-card {
  max-width: 400px;

  .modal-card-head {
    background-color: #fff;
    border-bottom: 1px solid #e0e0e0;
    padding: 16px 20px;

    .modal-card-title {
      color: #4f3f82;
      font-weight: 600;
    }
  }

  .modal-card-body {
    padding: 20px;
    color: #666;
    line-height: 1.5;
  }
}
</style>
